export const LOCALE_CATALOGUE = [
    { code: "en", label: "English", native: "English" },
    { code: "sv", label: "Swedish", native: "Svenska" },
    { code: "no", label: "Norwegian", native: "Norsk" },
    { code: "da", label: "Danish", native: "Dansk" },
    { code: "fi", label: "Finnish", native: "Suomi" },
    { code: "de", label: "German", native: "Deutsch" },
    { code: "fr", label: "French", native: "Français" },
    { code: "es", label: "Spanish", native: "Español" },
    { code: "it", label: "Italian", native: "Italiano" },
    { code: "nl", label: "Dutch", native: "Nederlands" },
    { code: "pt", label: "Portuguese", native: "Português" },
    { code: "pl", label: "Polish", native: "Polski" },
    { code: "ru", label: "Russian", native: "Русский" },
    { code: "zh", label: "Chinese", native: "中文" },
    { code: "ja", label: "Japanese", native: "日本語" },
    { code: "ar", label: "Arabic", native: "العربية" },
];
export function previewLocalized(value, defaultLocale = "en") {
    return resolveLocalized(value, defaultLocale, defaultLocale);
}
export function localeMeta(code) {
    var _a;
    return ((_a = LOCALE_CATALOGUE.find((l) => l.code === code)) !== null && _a !== void 0 ? _a : {
        code,
        label: code.toUpperCase(),
        native: code.toUpperCase(),
    });
}
export function resolveLocalized(value, locale, defaultLocale) {
    if (value == null)
        return "";
    if (typeof value === "string")
        return value;
    const active = value[locale];
    if (active && active.trim().length > 0)
        return active;
    const fallback = value[defaultLocale];
    if (fallback && fallback.trim().length > 0)
        return fallback;
    for (const v of Object.values(value)) {
        if (v && v.trim().length > 0)
            return v;
    }
    return "";
}
export function isLocalizedMap(value) {
    if (!value || typeof value === "string")
        return false;
    return Object.values(value).some((v) => v && v.trim().length > 0);
}
export function setLocalized(current, locale, defaultLocale, next) {
    const map = typeof current === "string"
        ? current.trim().length > 0
            ? { [defaultLocale]: current }
            : {}
        : { ...(current !== null && current !== void 0 ? current : {}) };
    if (next.trim().length === 0) {
        delete map[locale];
    }
    else {
        map[locale] = next;
    }
    const keys = Object.keys(map).filter((k) => map[k] && map[k].trim().length > 0);
    if (keys.length === 0)
        return "";
    if (keys.length === 1 && keys[0] === defaultLocale)
        return map[defaultLocale];
    const pruned = {};
    for (const k of keys)
        pruned[k] = map[k];
    return pruned;
}
export function readLocalized(value, locale) {
    var _a;
    if (!value)
        return "";
    if (typeof value === "string") {
        return value;
    }
    return (_a = value[locale]) !== null && _a !== void 0 ? _a : "";
}
